(function () {
  function init(root) {
    if (!root || root.dataset.sandhyaReady === 'true') return;
    root.dataset.sandhyaReady = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-sandhya-panel-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sandhya-panel]'));

    var themeRows = Array.prototype.slice.call(root.querySelectorAll('[data-sandhya-theme]'));
    var productCards = Array.prototype.slice.call(root.querySelectorAll('[data-sandhya-product-themes]'));
    var timeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sandhya-time]'));
    var status = root.querySelector('[data-sandhya-filter-status]');
    var shopPanel = root.querySelector('[data-sandhya-panel="shop"]');
    var headerHost = root.closest('store-header') || root.closest('.header') || root.parentElement;

    var featureTitle = root.querySelector('[data-sandhya-feature-title]');
    var featureText = root.querySelector('[data-sandhya-feature-text]');
    var featureImage = root.querySelector('[data-sandhya-feature-image]');
    var featureImageWrap = root.querySelector('[data-sandhya-feature-image-wrap]');
    var featureSets = root.querySelector('[data-sandhya-feature-sets]');
    var featureSetRows = root.querySelector('[data-sandhya-feature-set-rows]');

    var defaultFeature = {
      title: featureTitle ? featureTitle.textContent : '',
      text: featureText ? featureText.innerHTML : '',
      image: featureImage ? featureImage.getAttribute('src') || '' : ''
    };

    var pinned = null;
    var hovered = null;

    function same(a, b) {
      return !!(a && b && a.type === b.type && a.key === b.key);
    }

    function activeSelection() {
      return pinned || hovered;
    }

    function resetShopState() {
      pinned = null;
      hovered = null;
      updateShop();
    }

    function resetNavOnly() {
      triggers.forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = true;
      });
    }

    function closePanels() {
      resetNavOnly();
      resetShopState();
    }

    function openPanel(name) {
      var target = root.querySelector('[data-sandhya-panel="' + name + '"]');
      var trigger = root.querySelector('[data-sandhya-panel-trigger="' + name + '"]');
      if (!target || !trigger) return;

      var wasOpen = !target.hidden;
      resetNavOnly();

      if (wasOpen) {
        resetShopState();
        return;
      }

      if (name === 'shop') resetShopState();

      target.hidden = false;
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        openPanel(btn.dataset.sandhyaPanelTrigger);
      });

      btn.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover) and (min-width: 1150px)').matches) {
          var target = root.querySelector('[data-sandhya-panel="' + btn.dataset.sandhyaPanelTrigger + '"]');
          if (target && target.hidden) openPanel(btn.dataset.sandhyaPanelTrigger);
        }
      });
    });

    function getThemeConfig(key) {
      var configs = Array.prototype.slice.call(
        root.querySelectorAll('[data-sandhya-theme-config="' + key + '"]')
      );
      if (!configs.length) return null;
      var editorConfig = configs.filter(function (node) {
        return node.dataset.source === 'theme-editor';
      });
      return editorConfig.length ? editorConfig[editorConfig.length - 1] : configs[configs.length - 1];
    }

    function clearSetRows() {
      if (featureSetRows) featureSetRows.innerHTML = '';
    }

    function renderDefaultFeature() {
      if (featureTitle) featureTitle.textContent = defaultFeature.title;
      if (featureText) featureText.innerHTML = defaultFeature.text;

      if (featureImage) {
        if (defaultFeature.image) {
          featureImage.src = defaultFeature.image;
          if (featureImageWrap) featureImageWrap.hidden = false;
        } else if (featureImageWrap) {
          featureImageWrap.hidden = true;
        }
      }

      clearSetRows();
      if (featureSets) featureSets.hidden = true;
    }

    function renderThemeFeature(key) {
      var row = root.querySelector('[data-sandhya-theme="' + key + '"]');
      var config = getThemeConfig(key);
      if (!row) {
        renderDefaultFeature();
        return;
      }

      var title = config && config.dataset.title ? config.dataset.title : row.dataset.sandhyaThemeTitle || '';
      var text = config && config.dataset.text ? config.dataset.text : '';
      var image = config && config.dataset.image ? config.dataset.image : row.dataset.sandhyaThemeImage || '';

      if (featureTitle) featureTitle.textContent = title;
      if (featureText) featureText.textContent = text;

      if (featureImage) {
        if (image) {
          featureImage.src = image;
          featureImage.alt = title;
          if (featureImageWrap) featureImageWrap.hidden = false;
        } else if (featureImageWrap) {
          featureImageWrap.hidden = true;
        }
      }

      clearSetRows();

      if (config && featureSetRows) {
        var sets = Array.prototype.slice.call(config.querySelectorAll('[data-sandhya-set]')).slice(0, 3);

        sets.forEach(function (set) {
          if (!set.dataset.name || !set.dataset.url) return;

          var link = document.createElement('a');
          link.className = 'sandhya-theme-set-link';
          link.href = set.dataset.url;

          var thumb = document.createElement('span');
          thumb.className = 'sandhya-theme-set-link__thumb';

          if (set.dataset.image) {
            var img = document.createElement('img');
            img.src = set.dataset.image;
            img.alt = set.dataset.name;
            img.loading = 'lazy';
            thumb.appendChild(img);
          }

          var copy = document.createElement('span');
          copy.className = 'sandhya-theme-set-link__copy';

          var strong = document.createElement('b');
          strong.textContent = set.dataset.name;
          copy.appendChild(strong);

          if (set.dataset.sub) {
            var small = document.createElement('small');
            small.textContent = set.dataset.sub;
            copy.appendChild(small);
          }

          var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          arrow.setAttribute('viewBox', '0 0 12 12');
          arrow.setAttribute('class', 'sandhya-theme-set-link__arrow');
          var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M2 6H10M6.5 2.5L10 6L6.5 9.5');
          arrow.appendChild(path);

          link.appendChild(thumb);
          link.appendChild(copy);
          link.appendChild(arrow);
          featureSetRows.appendChild(link);
        });
      }

      if (featureSets) {
        featureSets.hidden = !featureSetRows || !featureSetRows.children.length;
      }
    }

    function labelFor(selection) {
      if (!selection) return '';
      if (selection.type === 'theme') {
        var row = root.querySelector('[data-sandhya-theme="' + selection.key + '"]');
        return row ? (row.dataset.sandhyaThemeTitle || row.textContent.trim()) : selection.key;
      }
      var btn = root.querySelector('[data-sandhya-time="' + selection.key + '"]');
      return btn ? btn.textContent.trim().replace(/\s+/g, ' ') : selection.key;
    }

    function renderProductBadge(card, isMatch, hasFilter) {
      var badge = card.querySelector('[data-sandhya-product-badge]');
      if (!badge) return;

      badge.className = 'sandhya-product-card__badge';
      badge.textContent = '';

      if (hasFilter && isMatch) {
        badge.classList.add('is-visible', 'is-match');
        badge.textContent = '✓ Passt';
        return;
      }

      if (!hasFilter) {
        if (card.dataset.sandhyaStaticBadge === 'bestseller') {
          badge.classList.add('is-visible', 'is-bestseller');
          badge.textContent = '★ Bestseller';
        } else if (card.dataset.sandhyaStaticBadge === 'neu') {
          badge.classList.add('is-visible', 'is-new');
          badge.textContent = 'NEU';
        }
      }
    }

    function updateShop() {
      var active = activeSelection();
      var matches = 0;

      productCards.forEach(function (card) {
        var hit = null;

        if (active) {
          if (active.type === 'theme') {
            var themes = (card.dataset.sandhyaProductThemes || '').split(/\s+/).filter(Boolean);
            hit = themes.indexOf(active.key) !== -1;
          } else {
            var times = (card.dataset.sandhyaProductTimes || '').split(/\s+/).filter(Boolean);
            hit = times.indexOf(active.key) !== -1;
          }
        }

        card.classList.toggle('is-match', hit === true);
        card.classList.toggle('is-dimmed', hit === false);
        if (hit === true) matches += 1;
        renderProductBadge(card, hit === true, !!active);
      });

      themeRows.forEach(function (row) {
        var selection = { type: 'theme', key: row.dataset.sandhyaTheme };
        row.classList.toggle('is-active', same(active, selection));
        row.classList.toggle('is-pinned', same(pinned, selection));
        row.setAttribute('aria-pressed', same(pinned, selection) ? 'true' : 'false');
      });

      timeButtons.forEach(function (btn) {
        var selection = { type: 'time', key: btn.dataset.sandhyaTime };
        btn.classList.toggle('is-active', same(active, selection));
        btn.classList.toggle('is-pinned', same(pinned, selection));
        btn.setAttribute('aria-pressed', same(pinned, selection) ? 'true' : 'false');
      });

      if (status) {
        status.textContent = active
          ? matches + ' passend zu „' + labelFor(active) + '“'
          : 'Thema links wählen, um zu filtern';
      }

      var themeToRender = null;
      if (active && active.type === 'theme') themeToRender = active.key;
      else if (pinned && pinned.type === 'theme') themeToRender = pinned.key;

      if (themeToRender) renderThemeFeature(themeToRender);
      else renderDefaultFeature();
    }

    function hoverSelection(type, key) {
      hovered = { type: type, key: key };
      updateShop();
    }

    function pinSelection(type, key) {
      var candidate = { type: type, key: key };
      pinned = same(pinned, candidate) ? null : candidate;
      hovered = candidate;
      updateShop();
    }

    themeRows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        hoverSelection('theme', row.dataset.sandhyaTheme);
      });
      row.addEventListener('click', function () {
        pinSelection('theme', row.dataset.sandhyaTheme);
      });
    });

    timeButtons.forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        hoverSelection('time', button.dataset.sandhyaTime);
      });
      button.addEventListener('click', function () {
        pinSelection('time', button.dataset.sandhyaTime);
      });
    });

    if (shopPanel) {
      shopPanel.addEventListener('mouseleave', function () {
        hovered = null;
        updateShop();
      });
    }

    /*
     * Close the complete desktop mega menu only after the mouse leaves
     * the OUTER header/mega-menu area. Moving between the header nav and
     * an open mega panel does not close it because the panel is a descendant
     * of the header.
     */
    if (headerHost) {
      headerHost.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: hover) and (min-width: 1150px)').matches) {
          closePanels();
        }
      });
    }

    /*
     * Shopify Theme Editor:
     * selecting one of the Passende-Sets blocks opens Shop and previews
     * the corresponding theme immediately.
     */
    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (!block || !block.matches || !block.matches('[data-sandhya-theme-config]')) return;

      var key = block.getAttribute('data-sandhya-theme-config');
      if (!key) return;

      var shopTarget = root.querySelector('[data-sandhya-panel="shop"]');
      if (shopTarget && shopTarget.hidden) openPanel('shop');

      hovered = { type: 'theme', key: key };
      pinned = null;
      updateShop();
    });

    updateShop();

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanels();
    });

    var drawer = root.querySelector('[data-sandhya-mobile-drawer]');
    var openBtn = root.querySelector('[data-sandhya-mobile-open]');

    if (drawer && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    function openMobile() {
      if (!drawer) return;
      drawer.hidden = false;
      document.documentElement.classList.add('sandhya-menu-open');
      document.body.classList.add('sandhya-menu-open');

      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');

      var closeButton = drawer.querySelector('.sandhya-mobile-drawer__close');
      if (closeButton) {
        setTimeout(function () { closeButton.focus(); }, 20);
      }
    }

    function closeMobile() {
      if (!drawer) return;
      drawer.hidden = true;
      document.documentElement.classList.remove('sandhya-menu-open');
      document.body.classList.remove('sandhya-menu-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn) {
      openBtn.addEventListener('click', function (event) {
        event.preventDefault();
        openMobile();
      });
    }

    if (drawer) {
      Array.prototype.slice.call(drawer.querySelectorAll('[data-sandhya-mobile-close]')).forEach(function (button) {
        button.addEventListener('click', closeMobile);
      });
    }

    var accordionTriggers = drawer
      ? Array.prototype.slice.call(drawer.querySelectorAll('[data-sandhya-accordion-trigger]'))
      : [];

    accordionTriggers.forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('.sandhya-mobile-accordion__group');
        var content = group && group.querySelector('[data-sandhya-accordion-content]');
        var willOpen = button.getAttribute('aria-expanded') !== 'true';

        accordionTriggers.forEach(function (other) {
          var otherGroup = other.closest('.sandhya-mobile-accordion__group');
          var otherContent = otherGroup && otherGroup.querySelector('[data-sandhya-accordion-content]');
          other.setAttribute('aria-expanded', 'false');
          if (otherContent) otherContent.hidden = true;
        });

        if (willOpen) {
          button.setAttribute('aria-expanded', 'true');
          if (content) content.hidden = false;
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanels();
        closeMobile();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sandhya-menu]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
